import Matrix from "./matrix";
import Vector from "./vector";

export function unilateralAlloc(
  tranches: Matrix<"tranche", "evaluable+hold">,
  budget: number,
): Vector<"evaluable+hold"> {
  const [numEvaluators, numEvaluables] = tranches.shape;
  if (budget === 0) {
    return Vector.zeros(numEvaluables);
  }
  const i = firstRowUsingWholeBudget(tranches, budget);

  // TODO: this happens when the tranche list absorbs the whole budget. When/if
  // that happens should the rest of the budget be sent to hold? (which, by
  // convention, should be the first column)
  if (i === -1) {
    return tranches.getRow(numEvaluators - 1);
  }

  const fullyUsed =
    i > 0
      ? tranches.getRow(i - 1)
      : Vector.zeros<"evaluable+hold">(numEvaluables);

  const fullyUsedBudget = fullyUsed.sum();
  const marginal = tranches.getRow(i).subtract(fullyUsed);
  const marginalTotal = marginal.sum();
  const scale = (budget - fullyUsedBudget) / marginalTotal;

  return fullyUsed.add(marginal.multiply(scale));
}

function firstRowUsingWholeBudget(
  tranches: Matrix<"tranche", "evaluable+hold">,
  budget: number,
): number {
  for (let i = 0; i < tranches.shape[0]; i++) {
    if (tranches.getRow(i).sum() >= budget) return i;
  }

  return -1;
}
